import { render, staticRenderFns } from "./CenterTemplate.vue?vue&type=template&id=d4b973cc&scoped=true&"
import script from "./CenterTemplate.vue?vue&type=script&lang=js&"
export * from "./CenterTemplate.vue?vue&type=script&lang=js&"
import style0 from "./CenterTemplate.vue?vue&type=style&index=0&id=d4b973cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4b973cc",
  null
  
)

export default component.exports